import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '../../static/播放.png'
import _imports_1 from '../../static/video/video.mp4'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "playImg"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("source", {
  src: _imports_1,
  type: "video/mp4"
}, null, -1)
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_home = _resolveComponent("game-home")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isShowVideo)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.playStatus)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("img", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args))),
                  src: _imports_0,
                  alt: ""
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.tiaoguoStatus)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeVideo && _ctx.closeVideo(...args))),
                class: "tiaoguo"
              }, "跳过"))
            : _createCommentVNode("", true),
          _createVNode("video", {
            autoplay: "",
            "x5-video-player-type": "h5",
            width: "100vw",
            height: "100vh",
            "x5-video-player-fullscreen": "true",
            playsinline: "true",
            "webkit-playsinline": "true",
            id: "videoM3u8",
            class: "vjs-tech",
            poster: _ctx.posterImg,
            controls: ""
          }, [
            _hoisted_4
          ], 8, ["poster"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isShowVideo)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_game_home)
        ]))
      : _createCommentVNode("", true)
  ]))
}